(function (module) {
    "use strict";

    module.service("imsDataCommonService", [
        "$rootScope",
        function (this: $TSFixMe, $rootScope: ng.IRootScopeService) {
            var service = this;

            service.updateBrandHistoricalDataForSkuForecast = function (
                brandGroup: $TSFixMe,
                brandGroupServerData: $TSFixMe,
                forecastLength: $TSFixMe,
                parameters: $TSFixMe
            ) {
                brandGroup.forecast.historicalMksh = brandGroupServerData.historicalData.mkshr;
                brandGroup.forecast.historicalValueData = brandGroupServerData.historicalData.value;
                if (parameters.forecastType.typeId == "dot") {
                    brandGroup.forecast.historicalDotData = brandGroupServerData.historicalData.dot;
                } else {
                    brandGroup.forecast.historicalVolumeData = brandGroupServerData.historicalData.volume;
                }
            };

            service.updateSkuHistoricalDataForMkshrForecast = function (
                sku: $TSFixMe,
                serverSku: $TSFixMe,
                forecastLength: $TSFixMe,
                parameters: $TSFixMe
            ) {
                sku.forecast.historicalPrice = serverSku.price;
                sku.forecast.historicalMkshr = serverSku.mkshr;

                sku.forecast.historicalValueData = angular._get(serverSku, "data.value", []);

                sku.forecast.historicalVolumeData = angular._get(serverSku, "data.volume", []);
                if (parameters.forecastType.typeId == "dot") {
                    sku.forecast.historicalDotData = angular._get(serverSku, "data.dot", []);
                }
                sku.forecast.exFactory = service.createExFactory(serverSku);
            };

            service.updateBrandHistoricalDataForMkshrForecast = function (
                brandGroup: $TSFixMe,
                brandGroupServerData: $TSFixMe,
                forecastLength: $TSFixMe,
                parameters: $TSFixMe
            ) {
                brandGroup.forecast.historicalValueData = brandGroupServerData.historicalData.value;
                brandGroup.forecast.historicalMksh = brandGroupServerData.historicalData.mkshr;
                brandGroup.forecast.historicalVolumeData = brandGroupServerData.historicalData.volume;
                if (parameters.forecastType.typeId == "dot") {
                    brandGroup.forecast.historicalDotData = brandGroupServerData.historicalData.dot;
                }
            };

            service.updateHistoricalDataForMarketForecast = function (
                forecast: $TSFixMe,
                data: $TSFixMe,
                parameters: $TSFixMe
            ) {
                forecast.historicalValueData = data.value;

                if (parameters.forecastType.typeId == "dot") {
                    forecast.historicalData = data.dot;
                } else {
                    forecast.historicalData = data.volume;
                }
            };

            service.calculateSkuHistoricalData = function (
                sku: $TSFixMe,
                serverSku: $TSFixMe,
                brandGroupServerData: $TSFixMe,
                parameters: $TSFixMe
            ) {
                var extractDataByForecastType = extractDataByType(parameters.forecastType.typeId)!;

                for (let i = 0; i < serverSku.data.value.length; i++) {
                    sku.forecast.historicalPrice[i] = serverSku.data.value[i] / serverSku.data.volume[i];
                }
                for (let i = 0; i < serverSku.data.value.length; i++) {
                    sku.forecast.historicalBrandShr[i] =
                        extractDataByForecastType(serverSku.data)[i] /
                        extractDataByForecastType(brandGroupServerData.historicalData)[i];
                }
            };

            service.arraysAreEqual = function (array1: $TSFixMe, array2: $TSFixMe) {
                return array1.length === array2.length && array1.length === _.intersection(array1, array2).length;
            };

            service.prepareSkuData = function (serverSkus: $TSFixMe, product: $TSFixMe, forecastTypeId: $TSFixMe) {
                var extractor = extractDataByType(forecastTypeId);

                for (const s of _.filter(serverSkus, (sku: $TSFixMe) => sku.data)) {
                    s.mkshr = [];
                    s.price = [];
                    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                    var productValues = extractor(product);
                    for (let i = 0; i < s.data.value.length; i++) {
                        s.price.push(calculatePrice(s.data, i, forecastTypeId));
                        var j = productValues.length - s.data.value.length + i;
                        // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
                        let divider = extractor(product)[j];
                        if (divider == 0) {
                            s.mkshr.push(0);
                        } else {
                            // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
                            s.mkshr.push(extractor(s.data)[i] / divider);
                        }
                    }
                }
                return serverSkus;
            };

            service.createExFactory = (serverSku: $TSFixMe) => {
                return {
                    sales: serverSku.sales,
                    salesTo: serverSku.salesTo,
                    salesFrom: serverSku.salesFrom,
                    itemsInStock: serverSku.itemsInStock,
                    originalItemsInStock: serverSku.itemsInStock,
                    itemsInStockDate: serverSku.itemsInStockDate,
                    rotation: serverSku.rotation,
                    originalRotation: serverSku.rotation,
                    historicalValueData: serverSku.exFactoryHistoricalData.value,
                    historicalVolumeData: serverSku.exFactoryHistoricalData.volume,
                    algorithmType: "ExFactorySlidingWindowCalculator"
                };
            };

            service.createMlData = (forecastUId: $TSFixMe, oracleIndex = null) => {
                return [1, 3, 5, 7].map(avg => ({
                    modelId: `${forecastUId}_${avg}` + (oracleIndex ? `_${oracleIndex}` : ""),
                    monthNumberForAverage: avg,
                    calculationIsReady: false
                }));
            };

            function calculatePrice(data: $TSFixMe, i: $TSFixMe, forecastTypeId: $TSFixMe) {
                if (forecastTypeId == "dot") return data.value[i] / data.dot[i];
                else return data.value[i] / data.volume[i];
            }

            function extractDataByType(forecastTypeId: $TSFixMe) {
                switch (forecastTypeId) {
                    case "dot":
                        return (x: $TSFixMe) => x.dot;
                    case "value":
                        return (x: $TSFixMe) => x.value;
                    case "volume":
                        return (x: $TSFixMe) => x.volume;
                }
            }
        }
    ]);
})(angular.module("topline.services"));
